import styled from "styled-components";

const INK = "#14202b";
const PEACH = "#fdad73";
const PEACH_DEEP = "#fd944d";
const BLUSH = "#FFE3E3";
const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

export const PageIntroWrapper = styled.section`
	position: relative;
	isolation: isolate;
	padding: 56px 0 24px;

	/* Soft blush and blue glow behind the headline; decorative only. */
	&::before {
		content: "";
		position: absolute;
		z-index: -1;
		inset: -120px -12vw auto -12vw;
		height: 520px;
		background:
			radial-gradient(40% 55% at 12% 30%, ${BLUSH}, transparent 70%),
			radial-gradient(38% 50% at 88% 20%, rgba(120, 157, 188, 0.28), transparent 70%),
			radial-gradient(30% 40% at 60% 75%, rgba(253, 173, 115, 0.16), transparent 70%);
		-webkit-mask-image: linear-gradient(90deg, transparent, #000 14%, #000 86%, transparent);
		mask-image: linear-gradient(90deg, transparent, #000 14%, #000 86%, transparent);
		pointer-events: none;
	}

	h1 {
		margin: 0;
		font-family: var(--poppins), "Poppins", sans-serif;
		font-weight: 700;
		font-size: clamp(30px, 3.6vw, 48px);
		line-height: 1.1;
		letter-spacing: -0.03em;
		color: ${INK};
	}

	.accent {
		width: 48px;
		height: 4px;
		margin-top: 20px;
		border-radius: 5px;
		background: linear-gradient(90deg, ${PEACH}, ${PEACH_DEEP});
	}

	&& p {
		margin: 24px 0 0;
		max-width: 60ch;
		font-family: var(--poppins), "Poppins", sans-serif;
		font-size: clamp(16px, 1.6vw, 20px);
		line-height: 1.7;
		color: ${({ theme }) => theme.palette.text.secondary};
	}

	@media (prefers-reduced-motion: no-preference) {
		h1,
		.accent,
		p {
			animation: intro-in 0.9s ${EASE} both;
		}
		.accent {
			animation-delay: 0.08s;
			transform-origin: left;
			animation-name: intro-line;
		}
		p {
			animation-delay: 0.16s;
		}
		@keyframes intro-in {
			from {
				opacity: 0;
				transform: translateY(24px);
			}
			to {
				opacity: 1;
				transform: none;
			}
		}
		@keyframes intro-line {
			from {
				opacity: 0;
				transform: scaleX(0);
			}
			to {
				opacity: 1;
				transform: none;
			}
		}
	}

	${props => props.theme.breakpoints.down("md")} {
		padding: 32px 0 8px;
		.accent {
			margin-top: 20px;
		}
		&& p {
			margin-top: 18px;
		}
	}
`;

